import { gql } from "@outschool/ui-apollo";

export default gql`
  mutation SendMessageToOutschool($messageInput: MessageInput!) {
    sendMessageToOutschool(messageInput: $messageInput)
  }
`;
